// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: common/error.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "common";

/**
 * An error code provides additional information about a failed API request.
 *
 * INTERNAL
 *
 * These error codes will be returned by the REST API to the clients.
 *
 * Use numbering of enums to group related error codes. So for exampe,
 * all errors relating to fabrics might have error codes in the range 1000-1099,
 * while chassis might be 1100-1199 and so on.
 *
 * Avoid using number ranges that might overlap with http status codes. So
 * nothing in the 5XX range or less.
 *
 * While comments are not required on the enums it should be noted that at some
 * point we may need to document these in some publicly available website so that
 * users can get some additional details on some specific error. In cases where a
 * comment would be useful a short leading comment is preferred.
 *
 *  // Badly formed UUID value.
 *  ERR_CODE_INVALID_UUID = 2;
 *
 * rather than:
 *
 *  ERR_CODE_INVALID_UUID = 2; // Badly formed UUID value.
 *
 * See suggested ranges below for enum values.
 */
export enum ErrCode {
  ERR_CODE_UNSPECIFIED = 0,
  /** ERR_CODE_INTERNAL - Generic errors, 1-49 */
  ERR_CODE_INTERNAL = 1,
  ERR_CODE_INVALID_UUID = 2,
  ERR_CODE_PERMISSION_DENIED = 3,
  ERR_CODE_OUT_OF_RANGE = 4,
  ERR_CODE_INVALID_TYPE = 5,
  ERR_CODE_INVALID_VALUE = 6,
  ERR_CODE_UNKNOWN_PARAMETER = 7,
  ERR_CODE_SERVICE_UNAVAILABLE = 8,
  ERR_CODE_NOT_FOUND = 9,
  ERR_CODE_NOT_IMPLEMENTED = 10,
  ERR_CODE_TOO_MANY_REQUESTS = 11,
  ERR_CODE_NO_KNOWN_CODE = 12,
  ERR_CODE_NO_REGISTERED_MARSHALERS = 13,
  ERR_CODE_UNSUPPORTED_CONTENT_TYPE = 14,
  ERR_CODE_DATA_CONFLICT = 15,
  ERR_CODE_UNAUTHORIZED = 16,
  ERR_CODE_READ_ONLY_FIELD = 17,
  ERR_CODE_MISSING_REQUIRED_ARG = 18,
  ERR_CODE_REQUEST_VALIDATION = 19,
  ERR_CODE_INVALID_CLI_CMD = 20,
  ERR_CODE_UNSUPPORTED_VALUE = 21,
  ERR_CODE_METHOD_NOT_ALLOWED = 22,
  ERR_CODE_MAX_LIMIT_EXCEEDED = 23,
  ERR_CODE_CANNOT_UPDATE_MODEL_FOR_GROUP = 24,
  /** ERR_CODE_JSON_UNMARSHAL_ERROR - Marshal/unmarshal errors. */
  ERR_CODE_JSON_UNMARSHAL_ERROR = 100,
  ERR_CODE_JSON_MARSHAL_ERROR = 101,
  ERR_CODE_JSON_NO_DATA = 102,
  ERR_CODE_CSV_UNMARSHAL_ERROR = 103,
  ERR_CODE_CSV_MARSHAL_ERROR = 104,
  ERR_CODE_CSV_INVALID_DATA = 105,
  ERR_CODE_CSV_UNKNOWN_HEADER = 106,
  ERR_CODE_CSV_INVALID_VALUE = 107,
  ERR_CODE_CSV_NO_DATA = 108,
  ERR_CODE_YAML_NO_DATA = 109,
  ERR_CODE_YAML_UNMARSHAL_ERROR = 110,
  ERR_CODE_YAML_MARSHAL_ERROR = 111,
  ERR_CODE_PEM_NO_DATA = 120,
  ERR_CODE_PEM_UNMARSHAL_ERROR = 121,
  ERR_CODE_PEM_MARSHAL_ERROR = 122,
  ERR_CODE_PEM_INVALID_KEY_TYPE = 123,
  ERR_CODE_PEM_INVALID_KEY_DATA = 124,
  ERR_CODE_FORM_MARSHAL_ERROR = 125,
  ERR_CODE_FORM_UNMARSHAL_ERROR = 126,
  ERR_CODE_FORM_NO_DATA = 127,
  /** ERR_CODE_NO_FABRICS_DEFINED - Fabric errors, 1000-1049 */
  ERR_CODE_NO_FABRICS_DEFINED = 1000,
  ERR_CODE_NO_FABRIC_CONNECTIONS_DEFINED = 1001,
  ERR_CODE_TOO_MANY_FABRICS_DEFINED = 1002,
  /** ERR_CODE_CHASSIS_ALREADY_ASSIGNED - Chassis errors, 1050-1099 */
  ERR_CODE_CHASSIS_ALREADY_ASSIGNED = 1050,
  ERR_CODE_NO_PORTS_FOR_CHASSIS = 1051,
  /** ERR_CODE_INVALID_CONFIRMATION_CODE - Notification Endpoint errors, 1100-1049 */
  ERR_CODE_INVALID_CONFIRMATION_CODE = 1100,
  /**
   * ERR_CODE_PROXY_UNKNOWN_ERROR - Fred errors 3000-3999
   * THESE NAMES ARE CUSTOMER FACING
   * Each code should be used in only one place and deprecated if no longer needed.
   */
  ERR_CODE_PROXY_UNKNOWN_ERROR = 3000,
  /** ERR_CODE_PROXY_TRANSPORT_ERROR - an error between fred and the destination service (i.e. a network error) */
  ERR_CODE_PROXY_TRANSPORT_ERROR = 3001,
  /** ERR_CODE_PROXY_UNKNOWN_ROUTE - SNO - get tempate path from request url */
  ERR_CODE_PROXY_UNKNOWN_ROUTE = 3002,
  /** ERR_CODE_PROXY_INVALID_WS_SVC - i.e. /ws?svc=invalid */
  ERR_CODE_PROXY_INVALID_WS_SVC = 3003,
  /**
   * ERR_CODE_PROXY_INVALID_WS_PATH - DEPRECATED
   *
   * @deprecated
   */
  ERR_CODE_PROXY_INVALID_WS_PATH = 3004,
  /** ERR_CODE_PROXY_INVALID_WS_FABRIC_ID - /ws?svc=sextant&fabricId=invalid */
  ERR_CODE_PROXY_INVALID_WS_FABRIC_ID = 3005,
  /**
   * ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING - DEPRECATED
   *
   * @deprecated
   */
  ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING = 3006,
  /**
   * ERR_CODE_PROXY_AUTH_ERROR - DEPRECATED
   *
   * @deprecated
   */
  ERR_CODE_PROXY_AUTH_ERROR = 3007,
  /** ERR_CODE_PROXY_UNROUTABLE_APP - get HostPort given an SRP with an app type that is not routable */
  ERR_CODE_PROXY_UNROUTABLE_APP = 3008,
  /** ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP - tried to look up a cell pair mapping with a nil orgId */
  ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP = 3009,
  /** ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED - could not find the org in the OrgToCellPairMapping list */
  ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED = 3010,
  /** ERR_CODE_PROXY_NO_ACTIVE_SHARD - cell pair does not have an active cell */
  ERR_CODE_PROXY_NO_ACTIVE_SHARD = 3011,
  /** ERR_CODE_PROXY_INVALID_ROUTING_POLICY - invalid routing policy value */
  ERR_CODE_PROXY_INVALID_ROUTING_POLICY = 3012,
  /** ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND - could not find a load balanced service route for the specified cellId and app */
  ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND = 3013,
  /** ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND - could not find an assignment service route for the specified cellId, resourceId and app */
  ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND = 3014,
  /** ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY - found an assignment service route but it is not ready */
  ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY = 3015,
  /** ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID - error getting host and port for a load balanced service route */
  ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID = 3016,
  /** ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID - error getting host and port for an assignment service route */
  ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID = 3017,
  /** ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID - attempted to do assignment routing with an nil org id */
  ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID = 3018,
  /** ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID - attempted to do assignment routing with an nil org id */
  ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID = 3019,
  /** ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE - attempted to route by resource but the app is not routed by org or fabric */
  ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE = 3020,
  /** ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS - no cell is configued for new orgs */
  ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS = 3021,
  /** ERR_CODE_PROXY_EMPTY_FABRIC_NAME - a fabric was specified by an empty id/name */
  ERR_CODE_PROXY_EMPTY_FABRIC_NAME = 3022,
  /** ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME - a fabric was speicified by a name that could not be resolved to a fabric id */
  ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME = 3023,
  /** ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL - can't lookup a device by empty serial number */
  ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL = 3024,
  /** ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL - couldn't find a device with the specified serial number */
  ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL = 3025,
  /** ERR_CODE_PROXY_EMPTY_EMAIL - can't lookup a user by empty email */
  ERR_CODE_PROXY_EMPTY_EMAIL = 3026,
  /** ERR_CODE_PROXY_UNKNOWN_EMAIL - couldn't find a user with the specified email */
  ERR_CODE_PROXY_UNKNOWN_EMAIL = 3027,
  /** ERR_CODE_PROXY_AUTH_ERROR_CLAIMS - rest proxy claims check failed verification */
  ERR_CODE_PROXY_AUTH_ERROR_CLAIMS = 3028,
  /** ERR_CODE_PROXY_AUTH_ERROR_NO_ORG - rest proxy claims check failed, no org id */
  ERR_CODE_PROXY_AUTH_ERROR_NO_ORG = 3029,
  /** ERR_CODE_PROXY_AUTH_ERROR_TYPE - rest proxy claims check failed, invalid auth type */
  ERR_CODE_PROXY_AUTH_ERROR_TYPE = 3030,
  /** ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE - rest proxy claims check failed, no fabric id for device auth */
  ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE = 3031,
  /** ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID - rest proxy claims check failed, invalid device id for device auth */
  ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID = 3032,
  /** ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE - device specified in claims not found in device list */
  ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE = 3033,
  /** ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH - fabric id in device claims does not match the fabric id in the request */
  ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH = 3034,
  /** ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION - couldn't resolve redirect location */
  ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION = 3035,
  /** ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID - fabric id in header is not a valid uuid */
  ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID = 3036,
  /** ERR_CODE_PROXY_UNKNOWN_TENANT - the specified tenant id does not exist */
  ERR_CODE_PROXY_UNKNOWN_TENANT = 3037,
  /** ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID - can't lookup a hyperfabric org with an empty cui tenant id */
  ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID = 3038,
  /** ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID - specified cui tenant id does not exist */
  ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID = 3039,
  /** ERR_CODE_PROXY_CROSS_GEO_REDIRECT - cross-geo redirect failed */
  ERR_CODE_PROXY_CROSS_GEO_REDIRECT = 3040,
  /** ERR_CODE_PROXY_LEGACY_FORWARD_LOOP - loop detected on legacy agent proxy forward */
  ERR_CODE_PROXY_LEGACY_FORWARD_LOOP = 3041,
  /** ERR_CODE_PROXY_LEGACY_FORWARD_ERROR - legacy agent proxy forward failed */
  ERR_CODE_PROXY_LEGACY_FORWARD_ERROR = 3042,
  /** ERR_CODE_PROXY_GEO_MISMATCH - user session geo does not match the explicit geo URL */
  ERR_CODE_PROXY_GEO_MISMATCH = 3043,
  /** ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION - cell-pair is in transition state from active/standby */
  ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION = 3044,
  /** ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY - found a load balanced service route but no instance is ready to serve */
  ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY = 3045,
  /** ERR_CODE_PROXY_UNCLASSIFIED_ERROR - SNO - a non mxError was returned from the proxy */
  ERR_CODE_PROXY_UNCLASSIFIED_ERROR = 3999,
  /** ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY - Fabric configuration import/export/restore errors 4000-4199 */
  ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY = 4000,
  /** ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR - the fabric restore failed due to internal error */
  ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR = 4001,
  /** ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR - the fabric restore failed due to transaction error */
  ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR = 4002,
  /** ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND - the fabric restore failed due to revision not found */
  ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND = 4003,
  /** ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED - the fabric restore failed due to revision not design based */
  ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED = 4004,
  /** ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND - the fabric restore failed due to running configuration not found */
  ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND = 4005,
  /** ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED - the fabric restore failed due to running configuration not design based */
  ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED = 4006,
  /** ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE - the fabric restore warning for deleting the unused node */
  ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE = 4007,
  /** ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR - the fabric restore failed due to password error */
  ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR = 4008,
  /** ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR - the fabric restore failed due to empty password */
  ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR = 4009,
  /** ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR - the fabric restore failed due to internal password error */
  ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR = 4010,
  /** ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW - getting the deleted fabric failed due to exceed retention window */
  ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW = 4100,
  /** ERR_CODE_DELETED_FABRIC_NOT_FOUND - cannot find the deleted fabric */
  ERR_CODE_DELETED_FABRIC_NOT_FOUND = 4101,
  /** ERR_CODE_CLAIMS_UNKNOWN_DEVICE - Claims mismatch errors 4200-4299 */
  ERR_CODE_CLAIMS_UNKNOWN_DEVICE = 4200,
  /** ERR_CODE_CLAIMS_ORG_MISMATCH - org id mismatch */
  ERR_CODE_CLAIMS_ORG_MISMATCH = 4201,
  /** ERR_CODE_CLAIMS_FABRIC_MISMATCH - fabric id mismatch */
  ERR_CODE_CLAIMS_FABRIC_MISMATCH = 4202,
  /** ERR_CODE_CLAIMS_ORG_NOT_FOUND - org id cannot be found */
  ERR_CODE_CLAIMS_ORG_NOT_FOUND = 4203,
  /** ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND - provider cannot be found */
  ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND = 4204,
  /** ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND - user email cannot be found */
  ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND = 4205,
  /** ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND - tenant id cannot be found */
  ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND = 4206,
  /** ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND - session id cannot be found */
  ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND = 4207,
  /** ERR_CODE_RELAY_NO_HTTP_CONTEXT - gRPC-web Relay errors 4300-4399 */
  ERR_CODE_RELAY_NO_HTTP_CONTEXT = 4300,
  /** ERR_CODE_RELAY_AUTH_ERROR_CLAIMS - the grpc-web relay failed due to invlid claims */
  ERR_CODE_RELAY_AUTH_ERROR_CLAIMS = 4301,
  /** ERR_CODE_RELAY_AUTH_ERROR_NO_ORG - the grpc-web relay failed due to missing org id in claims */
  ERR_CODE_RELAY_AUTH_ERROR_NO_ORG = 4302,
  /** ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE - the grpc-web relay failed due to no fabric assignment in the request */
  ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE = 4303,
  /** ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID - the grpc-web relay failed due to missing device id */
  ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID = 4304,
  /** ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE - the grpc-web relay failed due to unknown device type */
  ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE = 4305,
  /** ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH - the grpc-web relay failed due to mismatch fabric */
  ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH = 4306,
  /** ERR_CODE_AUTH_UNKNOWN_SUBJECT - Auth errors 4400-4499 */
  ERR_CODE_AUTH_UNKNOWN_SUBJECT = 4400,
  /** ERR_CODE_AUTH_EMPTY_SUBJECT - can't lookup a user with empty subject */
  ERR_CODE_AUTH_EMPTY_SUBJECT = 4401,
  /** ERR_CODE_AUTH_EMPTY_PROVIDER - can't lookup a user with no provider */
  ERR_CODE_AUTH_EMPTY_PROVIDER = 4402,
  /** ERR_CODE_AUTH_INVALID_SUBJECT - can't lookup a user with an invalid subject */
  ERR_CODE_AUTH_INVALID_SUBJECT = 4403,
  /** ERR_CODE_AUTH_STALE_SESSION - session token was issued before the user's attributes were last modified */
  ERR_CODE_AUTH_STALE_SESSION = 4404,
  /** ERR_CODE_AUTH_USER_NOT_FOUND - user not found in the global users threadlist */
  ERR_CODE_AUTH_USER_NOT_FOUND = 4405,
  /** ERR_CODE_AUTH_ORG_MISMATCH - SNO - org id in claims does not match the org in system record */
  ERR_CODE_AUTH_ORG_MISMATCH = 4406,
  /** ERR_CODE_AUTH_TOKEN_EXPIRED - token has expired */
  ERR_CODE_AUTH_TOKEN_EXPIRED = 4407,
  /** ERR_CODE_AUTH_TOKEN_NOT_YET_VALID - token is not yet within its valid time window */
  ERR_CODE_AUTH_TOKEN_NOT_YET_VALID = 4408,
  /** ERR_CODE_AUTH_TOKEN_MALFORMED - token is malformed or cannot be parsed */
  ERR_CODE_AUTH_TOKEN_MALFORMED = 4409,
  /** ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID - token signature verification failed */
  ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID = 4410,
  /** ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID - token claims validation failed */
  ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID = 4411,
  /** ERR_CODE_AUTH_TOKEN_NOT_FOUND - token was not found */
  ERR_CODE_AUTH_TOKEN_NOT_FOUND = 4412,
  /** ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR - token validation failed with an expected error */
  ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR = 4413,
  /** ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR - token validation failed with an unexpected error */
  ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR = 4414,
  /** ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES - Resource reservation errors 4500-4600 */
  ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES = 4500,
  /** ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED - Image errors 4600-4699 */
  ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED = 4600,
  /** ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST - IdP/SSO errors 4700-4899 */
  ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST = 4700,
  ERR_CODE_IDP_GET_USER_INFO_ERROR = 4701,
  ERR_CODE_IDP_GET_USER_INFO_UNEXPECTED_RESPONSE_STATUS = 4702,
  ERR_CODE_IDP_GET_USER_INFO_INVALID_RESPONSE = 4703,
  ERR_CODE_IDP_LOGIN_NO_EMAIL = 4704,
  ERR_CODE_IDP_LOGIN_CANNOT_DETERMINE_REDIRECT_URI = 4705,
  ERR_CODE_IDP_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR = 4706,
  ERR_CODE_IDP_LOGIN_SET_SSO_STATE_TOKEN_ERROR = 4707,
  ERR_CODE_IDP_C3_LOGIN_CUI_DISABLED = 4708,
  ERR_CODE_IDP_C3_LOGIN_C3_LOGIN_DISABLED = 4709,
  ERR_CODE_IDP_C3_LOGIN_NO_EMAIL = 4710,
  ERR_CODE_IDP_C3_LOGIN_NO_SLOT_STATE = 4711,
  ERR_CODE_IDP_C3_LOGIN_NO_START_URL = 4712,
  ERR_CODE_IDP_C3_LOGIN_INVALID_START_URL = 4713,
  ERR_CODE_IDP_C3_LOGIN_CANNOT_DETERMINE_REDIRECT_URI = 4714,
  ERR_CODE_IDP_C3_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR = 4715,
  ERR_CODE_IDP_C3_LOGIN_SET_SSO_STATE_TOKEN_ERROR = 4716,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_CUI_DISABLED = 4717,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_C3_LOGIN_DISABLED = 4718,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_AUTH_CODE = 4719,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED = 4720,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED = 4721,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED = 4722,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMAIL_MISMATCH = 4723,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH = 4724,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_START_URL = 4725,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_MALFORMED_START_URL = 4726,
  ERR_CODE_IDP_LOGIN_CALLBACK_NO_STATE = 4727,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE = 4728,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE = 4729,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_START_URL = 4730,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_START_URL_DOMAIN = 4731,
  ERR_CODE_IDP_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE = 4732,
  ERR_CODE_IDP_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN = 4733,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN = 4734,
  ERR_CODE_IDP_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR = 4735,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL = 4736,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_START_URL = 4737,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT = 4738,
  ERR_CODE_IDP_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT = 4739,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE = 4740,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY = 4741,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_REDIRECT_URI = 4742,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT = 4743,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_NONCE = 4744,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY = 4745,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_EXPIRY = 4746,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_NONCE = 4747,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_EXPIRY = 4748,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_CUI_TENANT_ID = 4749,
  ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_PROVIDER = 4750,
  ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE = 4751,
  ERR_CODE_IDP_LOGOUT_CALLBACK_EXPIRED_SSO_LOGOUT_TOKEN = 4752,
  ERR_CODE_IDP_LOGOUT_CALLBACK_MISSING_SSO_LOGOUT_TOKEN = 4753,
  ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_LOGOUT_TOKEN_ERROR = 4754,
  ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_NONCE = 4755,
  ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL = 4756,
  ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL_DOMAIN = 4757,
  ERR_CODE_IDP_LOGOUT_CALLBACK_NO_STATE = 4758,
  ERR_CODE_IDP_LOGOUT_CALLBACK_MISMATCHED_SUBJECT = 4759,
  ERR_CODE_IDP_LOGIN_CALLBACK_NO_AUTH_CODE = 4760,
  ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED = 4761,
  ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED = 4762,
  ERR_CODE_IDP_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED = 4763,
  ERR_CODE_IDP_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH = 4764,
  ERR_CODE_IDP_LOGIN_CALLBACK_EMAIL_MISMATCH = 4765,
  ERR_CODE_IDP_LOGIN_CALLBACK_SANITY_CHECK_FAILED = 4766,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_USER_INFO_SUBJECT = 4767,
  ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_ID_TOKEN_SUBJECT = 4768,
  ERR_CODE_IDP_LOGIN_CALLBACK_SUBJECT_MISMATCH = 4769,
  ERR_CODE_IDP_REFRESH_NO_TOKEN = 4770,
  ERR_CODE_IDP_REFRESH_CANNOT_DETERMINE_CONFIGURATION = 4771,
  ERR_CODE_IDP_REFRESH_FAILED = 4772,
  ERR_CODE_IDP_REFRESH_INVALID_O2_TOKEN = 4773,
  ERR_CODE_IDP_REFRESH_SUBJECT_MISMATCH = 4774,
  ERR_CODE_IDP_LOGOUT_INVALID_ID_TOKEN = 4775,
  ERR_CODE_IDP_LOGOUT_INVALID_EMAIL_IN_ID_TOKEN = 4776,
  ERR_CODE_IDP_LOGOUT_MISSING_TENANT_NAME_PROVIDER_IN_ID_TOKEN = 4777,
  ERR_CODE_IDP_LOGOUT_UNEXPECTED_TENANT_NAME_PROVIDER_IN_ID_TOKEN = 4778,
  ERR_CODE_IDP_LOGOUT_CANNOT_DETERMINE_REDIRECT_URI = 4779,
  ERR_CODE_IDP_LOGOUT_CREATE_SSO_LOGOUT_TOKEN_ERROR = 4780,
  ERR_CODE_IDP_LOGOUT_SET_SSO_LOGOUT_TOKEN_ERROR = 4781,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE = 4782,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN = 4783,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN = 4784,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR = 4785,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT = 4786,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT = 4787,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE = 4788,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY = 4789,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL = 4790,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_STATE = 4791,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE = 4792,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE = 4793,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT = 4794,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_NONCE = 4795,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY = 4796,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE_EXPIRY = 4797,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_SUBJECT = 4798,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_NONCE = 4799,
  ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_EXPIRY = 4800,
  ERR_CODE_IDP_FORCE_AUTH_FAILED = 4801,
  ERR_CODE_SSO_REFRESH_INVALID_USER_SESSION_COOKIE = 4802,
  ERR_CODE_SSO_AUTH_LOGOUT_PARSE_FORM_ERROR = 4803,
  ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_PROVIDER_FROM_COOKIE_ERR = 4804,
  ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_USER_SESSION_COOKIE_ERR = 4805,
  ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_EMAIL_FROM_COOKIE_ERR = 4806,
  UNRECOGNIZED = -1,
}

export function errCodeFromJSON(object: any): ErrCode {
  switch (object) {
    case 0:
    case "ERR_CODE_UNSPECIFIED":
      return ErrCode.ERR_CODE_UNSPECIFIED;
    case 1:
    case "ERR_CODE_INTERNAL":
      return ErrCode.ERR_CODE_INTERNAL;
    case 2:
    case "ERR_CODE_INVALID_UUID":
      return ErrCode.ERR_CODE_INVALID_UUID;
    case 3:
    case "ERR_CODE_PERMISSION_DENIED":
      return ErrCode.ERR_CODE_PERMISSION_DENIED;
    case 4:
    case "ERR_CODE_OUT_OF_RANGE":
      return ErrCode.ERR_CODE_OUT_OF_RANGE;
    case 5:
    case "ERR_CODE_INVALID_TYPE":
      return ErrCode.ERR_CODE_INVALID_TYPE;
    case 6:
    case "ERR_CODE_INVALID_VALUE":
      return ErrCode.ERR_CODE_INVALID_VALUE;
    case 7:
    case "ERR_CODE_UNKNOWN_PARAMETER":
      return ErrCode.ERR_CODE_UNKNOWN_PARAMETER;
    case 8:
    case "ERR_CODE_SERVICE_UNAVAILABLE":
      return ErrCode.ERR_CODE_SERVICE_UNAVAILABLE;
    case 9:
    case "ERR_CODE_NOT_FOUND":
      return ErrCode.ERR_CODE_NOT_FOUND;
    case 10:
    case "ERR_CODE_NOT_IMPLEMENTED":
      return ErrCode.ERR_CODE_NOT_IMPLEMENTED;
    case 11:
    case "ERR_CODE_TOO_MANY_REQUESTS":
      return ErrCode.ERR_CODE_TOO_MANY_REQUESTS;
    case 12:
    case "ERR_CODE_NO_KNOWN_CODE":
      return ErrCode.ERR_CODE_NO_KNOWN_CODE;
    case 13:
    case "ERR_CODE_NO_REGISTERED_MARSHALERS":
      return ErrCode.ERR_CODE_NO_REGISTERED_MARSHALERS;
    case 14:
    case "ERR_CODE_UNSUPPORTED_CONTENT_TYPE":
      return ErrCode.ERR_CODE_UNSUPPORTED_CONTENT_TYPE;
    case 15:
    case "ERR_CODE_DATA_CONFLICT":
      return ErrCode.ERR_CODE_DATA_CONFLICT;
    case 16:
    case "ERR_CODE_UNAUTHORIZED":
      return ErrCode.ERR_CODE_UNAUTHORIZED;
    case 17:
    case "ERR_CODE_READ_ONLY_FIELD":
      return ErrCode.ERR_CODE_READ_ONLY_FIELD;
    case 18:
    case "ERR_CODE_MISSING_REQUIRED_ARG":
      return ErrCode.ERR_CODE_MISSING_REQUIRED_ARG;
    case 19:
    case "ERR_CODE_REQUEST_VALIDATION":
      return ErrCode.ERR_CODE_REQUEST_VALIDATION;
    case 20:
    case "ERR_CODE_INVALID_CLI_CMD":
      return ErrCode.ERR_CODE_INVALID_CLI_CMD;
    case 21:
    case "ERR_CODE_UNSUPPORTED_VALUE":
      return ErrCode.ERR_CODE_UNSUPPORTED_VALUE;
    case 22:
    case "ERR_CODE_METHOD_NOT_ALLOWED":
      return ErrCode.ERR_CODE_METHOD_NOT_ALLOWED;
    case 23:
    case "ERR_CODE_MAX_LIMIT_EXCEEDED":
      return ErrCode.ERR_CODE_MAX_LIMIT_EXCEEDED;
    case 24:
    case "ERR_CODE_CANNOT_UPDATE_MODEL_FOR_GROUP":
      return ErrCode.ERR_CODE_CANNOT_UPDATE_MODEL_FOR_GROUP;
    case 100:
    case "ERR_CODE_JSON_UNMARSHAL_ERROR":
      return ErrCode.ERR_CODE_JSON_UNMARSHAL_ERROR;
    case 101:
    case "ERR_CODE_JSON_MARSHAL_ERROR":
      return ErrCode.ERR_CODE_JSON_MARSHAL_ERROR;
    case 102:
    case "ERR_CODE_JSON_NO_DATA":
      return ErrCode.ERR_CODE_JSON_NO_DATA;
    case 103:
    case "ERR_CODE_CSV_UNMARSHAL_ERROR":
      return ErrCode.ERR_CODE_CSV_UNMARSHAL_ERROR;
    case 104:
    case "ERR_CODE_CSV_MARSHAL_ERROR":
      return ErrCode.ERR_CODE_CSV_MARSHAL_ERROR;
    case 105:
    case "ERR_CODE_CSV_INVALID_DATA":
      return ErrCode.ERR_CODE_CSV_INVALID_DATA;
    case 106:
    case "ERR_CODE_CSV_UNKNOWN_HEADER":
      return ErrCode.ERR_CODE_CSV_UNKNOWN_HEADER;
    case 107:
    case "ERR_CODE_CSV_INVALID_VALUE":
      return ErrCode.ERR_CODE_CSV_INVALID_VALUE;
    case 108:
    case "ERR_CODE_CSV_NO_DATA":
      return ErrCode.ERR_CODE_CSV_NO_DATA;
    case 109:
    case "ERR_CODE_YAML_NO_DATA":
      return ErrCode.ERR_CODE_YAML_NO_DATA;
    case 110:
    case "ERR_CODE_YAML_UNMARSHAL_ERROR":
      return ErrCode.ERR_CODE_YAML_UNMARSHAL_ERROR;
    case 111:
    case "ERR_CODE_YAML_MARSHAL_ERROR":
      return ErrCode.ERR_CODE_YAML_MARSHAL_ERROR;
    case 120:
    case "ERR_CODE_PEM_NO_DATA":
      return ErrCode.ERR_CODE_PEM_NO_DATA;
    case 121:
    case "ERR_CODE_PEM_UNMARSHAL_ERROR":
      return ErrCode.ERR_CODE_PEM_UNMARSHAL_ERROR;
    case 122:
    case "ERR_CODE_PEM_MARSHAL_ERROR":
      return ErrCode.ERR_CODE_PEM_MARSHAL_ERROR;
    case 123:
    case "ERR_CODE_PEM_INVALID_KEY_TYPE":
      return ErrCode.ERR_CODE_PEM_INVALID_KEY_TYPE;
    case 124:
    case "ERR_CODE_PEM_INVALID_KEY_DATA":
      return ErrCode.ERR_CODE_PEM_INVALID_KEY_DATA;
    case 125:
    case "ERR_CODE_FORM_MARSHAL_ERROR":
      return ErrCode.ERR_CODE_FORM_MARSHAL_ERROR;
    case 126:
    case "ERR_CODE_FORM_UNMARSHAL_ERROR":
      return ErrCode.ERR_CODE_FORM_UNMARSHAL_ERROR;
    case 127:
    case "ERR_CODE_FORM_NO_DATA":
      return ErrCode.ERR_CODE_FORM_NO_DATA;
    case 1000:
    case "ERR_CODE_NO_FABRICS_DEFINED":
      return ErrCode.ERR_CODE_NO_FABRICS_DEFINED;
    case 1001:
    case "ERR_CODE_NO_FABRIC_CONNECTIONS_DEFINED":
      return ErrCode.ERR_CODE_NO_FABRIC_CONNECTIONS_DEFINED;
    case 1002:
    case "ERR_CODE_TOO_MANY_FABRICS_DEFINED":
      return ErrCode.ERR_CODE_TOO_MANY_FABRICS_DEFINED;
    case 1050:
    case "ERR_CODE_CHASSIS_ALREADY_ASSIGNED":
      return ErrCode.ERR_CODE_CHASSIS_ALREADY_ASSIGNED;
    case 1051:
    case "ERR_CODE_NO_PORTS_FOR_CHASSIS":
      return ErrCode.ERR_CODE_NO_PORTS_FOR_CHASSIS;
    case 1100:
    case "ERR_CODE_INVALID_CONFIRMATION_CODE":
      return ErrCode.ERR_CODE_INVALID_CONFIRMATION_CODE;
    case 3000:
    case "ERR_CODE_PROXY_UNKNOWN_ERROR":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_ERROR;
    case 3001:
    case "ERR_CODE_PROXY_TRANSPORT_ERROR":
      return ErrCode.ERR_CODE_PROXY_TRANSPORT_ERROR;
    case 3002:
    case "ERR_CODE_PROXY_UNKNOWN_ROUTE":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_ROUTE;
    case 3003:
    case "ERR_CODE_PROXY_INVALID_WS_SVC":
      return ErrCode.ERR_CODE_PROXY_INVALID_WS_SVC;
    case 3004:
    case "ERR_CODE_PROXY_INVALID_WS_PATH":
      return ErrCode.ERR_CODE_PROXY_INVALID_WS_PATH;
    case 3005:
    case "ERR_CODE_PROXY_INVALID_WS_FABRIC_ID":
      return ErrCode.ERR_CODE_PROXY_INVALID_WS_FABRIC_ID;
    case 3006:
    case "ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING;
    case 3007:
    case "ERR_CODE_PROXY_AUTH_ERROR":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR;
    case 3008:
    case "ERR_CODE_PROXY_UNROUTABLE_APP":
      return ErrCode.ERR_CODE_PROXY_UNROUTABLE_APP;
    case 3009:
    case "ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP":
      return ErrCode.ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP;
    case 3010:
    case "ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED":
      return ErrCode.ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED;
    case 3011:
    case "ERR_CODE_PROXY_NO_ACTIVE_SHARD":
      return ErrCode.ERR_CODE_PROXY_NO_ACTIVE_SHARD;
    case 3012:
    case "ERR_CODE_PROXY_INVALID_ROUTING_POLICY":
      return ErrCode.ERR_CODE_PROXY_INVALID_ROUTING_POLICY;
    case 3013:
    case "ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND":
      return ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND;
    case 3014:
    case "ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND":
      return ErrCode.ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND;
    case 3015:
    case "ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY":
      return ErrCode.ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY;
    case 3016:
    case "ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID":
      return ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID;
    case 3017:
    case "ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID":
      return ErrCode.ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID;
    case 3018:
    case "ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID":
      return ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID;
    case 3019:
    case "ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID":
      return ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID;
    case 3020:
    case "ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE":
      return ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE;
    case 3021:
    case "ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS":
      return ErrCode.ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS;
    case 3022:
    case "ERR_CODE_PROXY_EMPTY_FABRIC_NAME":
      return ErrCode.ERR_CODE_PROXY_EMPTY_FABRIC_NAME;
    case 3023:
    case "ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME;
    case 3024:
    case "ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL":
      return ErrCode.ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL;
    case 3025:
    case "ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL;
    case 3026:
    case "ERR_CODE_PROXY_EMPTY_EMAIL":
      return ErrCode.ERR_CODE_PROXY_EMPTY_EMAIL;
    case 3027:
    case "ERR_CODE_PROXY_UNKNOWN_EMAIL":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_EMAIL;
    case 3028:
    case "ERR_CODE_PROXY_AUTH_ERROR_CLAIMS":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_CLAIMS;
    case 3029:
    case "ERR_CODE_PROXY_AUTH_ERROR_NO_ORG":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_NO_ORG;
    case 3030:
    case "ERR_CODE_PROXY_AUTH_ERROR_TYPE":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_TYPE;
    case 3031:
    case "ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE;
    case 3032:
    case "ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID;
    case 3033:
    case "ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE;
    case 3034:
    case "ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH":
      return ErrCode.ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH;
    case 3035:
    case "ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION":
      return ErrCode.ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION;
    case 3036:
    case "ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID":
      return ErrCode.ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID;
    case 3037:
    case "ERR_CODE_PROXY_UNKNOWN_TENANT":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_TENANT;
    case 3038:
    case "ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID":
      return ErrCode.ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID;
    case 3039:
    case "ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID":
      return ErrCode.ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID;
    case 3040:
    case "ERR_CODE_PROXY_CROSS_GEO_REDIRECT":
      return ErrCode.ERR_CODE_PROXY_CROSS_GEO_REDIRECT;
    case 3041:
    case "ERR_CODE_PROXY_LEGACY_FORWARD_LOOP":
      return ErrCode.ERR_CODE_PROXY_LEGACY_FORWARD_LOOP;
    case 3042:
    case "ERR_CODE_PROXY_LEGACY_FORWARD_ERROR":
      return ErrCode.ERR_CODE_PROXY_LEGACY_FORWARD_ERROR;
    case 3043:
    case "ERR_CODE_PROXY_GEO_MISMATCH":
      return ErrCode.ERR_CODE_PROXY_GEO_MISMATCH;
    case 3044:
    case "ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION":
      return ErrCode.ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION;
    case 3045:
    case "ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY":
      return ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY;
    case 3999:
    case "ERR_CODE_PROXY_UNCLASSIFIED_ERROR":
      return ErrCode.ERR_CODE_PROXY_UNCLASSIFIED_ERROR;
    case 4000:
    case "ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY;
    case 4001:
    case "ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR;
    case 4002:
    case "ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR;
    case 4003:
    case "ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND;
    case 4004:
    case "ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED;
    case 4005:
    case "ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND;
    case 4006:
    case "ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED;
    case 4007:
    case "ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE;
    case 4008:
    case "ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR;
    case 4009:
    case "ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR;
    case 4010:
    case "ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR":
      return ErrCode.ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR;
    case 4100:
    case "ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW":
      return ErrCode.ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW;
    case 4101:
    case "ERR_CODE_DELETED_FABRIC_NOT_FOUND":
      return ErrCode.ERR_CODE_DELETED_FABRIC_NOT_FOUND;
    case 4200:
    case "ERR_CODE_CLAIMS_UNKNOWN_DEVICE":
      return ErrCode.ERR_CODE_CLAIMS_UNKNOWN_DEVICE;
    case 4201:
    case "ERR_CODE_CLAIMS_ORG_MISMATCH":
      return ErrCode.ERR_CODE_CLAIMS_ORG_MISMATCH;
    case 4202:
    case "ERR_CODE_CLAIMS_FABRIC_MISMATCH":
      return ErrCode.ERR_CODE_CLAIMS_FABRIC_MISMATCH;
    case 4203:
    case "ERR_CODE_CLAIMS_ORG_NOT_FOUND":
      return ErrCode.ERR_CODE_CLAIMS_ORG_NOT_FOUND;
    case 4204:
    case "ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND":
      return ErrCode.ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND;
    case 4205:
    case "ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND":
      return ErrCode.ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND;
    case 4206:
    case "ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND":
      return ErrCode.ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND;
    case 4207:
    case "ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND":
      return ErrCode.ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND;
    case 4300:
    case "ERR_CODE_RELAY_NO_HTTP_CONTEXT":
      return ErrCode.ERR_CODE_RELAY_NO_HTTP_CONTEXT;
    case 4301:
    case "ERR_CODE_RELAY_AUTH_ERROR_CLAIMS":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_CLAIMS;
    case 4302:
    case "ERR_CODE_RELAY_AUTH_ERROR_NO_ORG":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_NO_ORG;
    case 4303:
    case "ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE;
    case 4304:
    case "ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID;
    case 4305:
    case "ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE;
    case 4306:
    case "ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH":
      return ErrCode.ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH;
    case 4400:
    case "ERR_CODE_AUTH_UNKNOWN_SUBJECT":
      return ErrCode.ERR_CODE_AUTH_UNKNOWN_SUBJECT;
    case 4401:
    case "ERR_CODE_AUTH_EMPTY_SUBJECT":
      return ErrCode.ERR_CODE_AUTH_EMPTY_SUBJECT;
    case 4402:
    case "ERR_CODE_AUTH_EMPTY_PROVIDER":
      return ErrCode.ERR_CODE_AUTH_EMPTY_PROVIDER;
    case 4403:
    case "ERR_CODE_AUTH_INVALID_SUBJECT":
      return ErrCode.ERR_CODE_AUTH_INVALID_SUBJECT;
    case 4404:
    case "ERR_CODE_AUTH_STALE_SESSION":
      return ErrCode.ERR_CODE_AUTH_STALE_SESSION;
    case 4405:
    case "ERR_CODE_AUTH_USER_NOT_FOUND":
      return ErrCode.ERR_CODE_AUTH_USER_NOT_FOUND;
    case 4406:
    case "ERR_CODE_AUTH_ORG_MISMATCH":
      return ErrCode.ERR_CODE_AUTH_ORG_MISMATCH;
    case 4407:
    case "ERR_CODE_AUTH_TOKEN_EXPIRED":
      return ErrCode.ERR_CODE_AUTH_TOKEN_EXPIRED;
    case 4408:
    case "ERR_CODE_AUTH_TOKEN_NOT_YET_VALID":
      return ErrCode.ERR_CODE_AUTH_TOKEN_NOT_YET_VALID;
    case 4409:
    case "ERR_CODE_AUTH_TOKEN_MALFORMED":
      return ErrCode.ERR_CODE_AUTH_TOKEN_MALFORMED;
    case 4410:
    case "ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID":
      return ErrCode.ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID;
    case 4411:
    case "ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID":
      return ErrCode.ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID;
    case 4412:
    case "ERR_CODE_AUTH_TOKEN_NOT_FOUND":
      return ErrCode.ERR_CODE_AUTH_TOKEN_NOT_FOUND;
    case 4413:
    case "ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR":
      return ErrCode.ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR;
    case 4414:
    case "ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR":
      return ErrCode.ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR;
    case 4500:
    case "ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES":
      return ErrCode.ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES;
    case 4600:
    case "ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED":
      return ErrCode.ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED;
    case 4700:
    case "ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST":
      return ErrCode.ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST;
    case 4701:
    case "ERR_CODE_IDP_GET_USER_INFO_ERROR":
      return ErrCode.ERR_CODE_IDP_GET_USER_INFO_ERROR;
    case 4702:
    case "ERR_CODE_IDP_GET_USER_INFO_UNEXPECTED_RESPONSE_STATUS":
      return ErrCode.ERR_CODE_IDP_GET_USER_INFO_UNEXPECTED_RESPONSE_STATUS;
    case 4703:
    case "ERR_CODE_IDP_GET_USER_INFO_INVALID_RESPONSE":
      return ErrCode.ERR_CODE_IDP_GET_USER_INFO_INVALID_RESPONSE;
    case 4704:
    case "ERR_CODE_IDP_LOGIN_NO_EMAIL":
      return ErrCode.ERR_CODE_IDP_LOGIN_NO_EMAIL;
    case 4705:
    case "ERR_CODE_IDP_LOGIN_CANNOT_DETERMINE_REDIRECT_URI":
      return ErrCode.ERR_CODE_IDP_LOGIN_CANNOT_DETERMINE_REDIRECT_URI;
    case 4706:
    case "ERR_CODE_IDP_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR;
    case 4707:
    case "ERR_CODE_IDP_LOGIN_SET_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGIN_SET_SSO_STATE_TOKEN_ERROR;
    case 4708:
    case "ERR_CODE_IDP_C3_LOGIN_CUI_DISABLED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CUI_DISABLED;
    case 4709:
    case "ERR_CODE_IDP_C3_LOGIN_C3_LOGIN_DISABLED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_C3_LOGIN_DISABLED;
    case 4710:
    case "ERR_CODE_IDP_C3_LOGIN_NO_EMAIL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_EMAIL;
    case 4711:
    case "ERR_CODE_IDP_C3_LOGIN_NO_SLOT_STATE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_SLOT_STATE;
    case 4712:
    case "ERR_CODE_IDP_C3_LOGIN_NO_START_URL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_START_URL;
    case 4713:
    case "ERR_CODE_IDP_C3_LOGIN_INVALID_START_URL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_INVALID_START_URL;
    case 4714:
    case "ERR_CODE_IDP_C3_LOGIN_CANNOT_DETERMINE_REDIRECT_URI":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CANNOT_DETERMINE_REDIRECT_URI;
    case 4715:
    case "ERR_CODE_IDP_C3_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR;
    case 4716:
    case "ERR_CODE_IDP_C3_LOGIN_SET_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_SET_SSO_STATE_TOKEN_ERROR;
    case 4717:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_CUI_DISABLED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_CUI_DISABLED;
    case 4718:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_C3_LOGIN_DISABLED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_C3_LOGIN_DISABLED;
    case 4719:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_AUTH_CODE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_AUTH_CODE;
    case 4720:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED;
    case 4721:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED;
    case 4722:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED;
    case 4723:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMAIL_MISMATCH":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMAIL_MISMATCH;
    case 4724:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH;
    case 4725:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_START_URL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_START_URL;
    case 4726:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MALFORMED_START_URL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MALFORMED_START_URL;
    case 4727:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_NO_STATE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_NO_STATE;
    case 4728:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE;
    case 4729:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE;
    case 4730:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_START_URL":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_START_URL;
    case 4731:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_START_URL_DOMAIN":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_START_URL_DOMAIN;
    case 4732:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE;
    case 4733:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN;
    case 4734:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN;
    case 4735:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR;
    case 4736:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL;
    case 4737:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_START_URL":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_START_URL;
    case 4738:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT;
    case 4739:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT;
    case 4740:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE;
    case 4741:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY;
    case 4742:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_REDIRECT_URI":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_REDIRECT_URI;
    case 4743:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT;
    case 4744:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_NONCE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_NONCE;
    case 4745:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY;
    case 4746:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_EXPIRY":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_EXPIRY;
    case 4747:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_NONCE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_NONCE;
    case 4748:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_EXPIRY":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_EXPIRY;
    case 4749:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_CUI_TENANT_ID":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_CUI_TENANT_ID;
    case 4750:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_PROVIDER":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_PROVIDER;
    case 4751:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE;
    case 4752:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_EXPIRED_SSO_LOGOUT_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_EXPIRED_SSO_LOGOUT_TOKEN;
    case 4753:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_MISSING_SSO_LOGOUT_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_MISSING_SSO_LOGOUT_TOKEN;
    case 4754:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_LOGOUT_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_LOGOUT_TOKEN_ERROR;
    case 4755:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_NONCE":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_NONCE;
    case 4756:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL;
    case 4757:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL_DOMAIN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL_DOMAIN;
    case 4758:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_NO_STATE":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_NO_STATE;
    case 4759:
    case "ERR_CODE_IDP_LOGOUT_CALLBACK_MISMATCHED_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_MISMATCHED_SUBJECT;
    case 4760:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_NO_AUTH_CODE":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_NO_AUTH_CODE;
    case 4761:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED;
    case 4762:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED;
    case 4763:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED;
    case 4764:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH;
    case 4765:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_EMAIL_MISMATCH":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMAIL_MISMATCH;
    case 4766:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_SANITY_CHECK_FAILED":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SANITY_CHECK_FAILED;
    case 4767:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_USER_INFO_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_USER_INFO_SUBJECT;
    case 4768:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_ID_TOKEN_SUBJECT":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_ID_TOKEN_SUBJECT;
    case 4769:
    case "ERR_CODE_IDP_LOGIN_CALLBACK_SUBJECT_MISMATCH":
      return ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SUBJECT_MISMATCH;
    case 4770:
    case "ERR_CODE_IDP_REFRESH_NO_TOKEN":
      return ErrCode.ERR_CODE_IDP_REFRESH_NO_TOKEN;
    case 4771:
    case "ERR_CODE_IDP_REFRESH_CANNOT_DETERMINE_CONFIGURATION":
      return ErrCode.ERR_CODE_IDP_REFRESH_CANNOT_DETERMINE_CONFIGURATION;
    case 4772:
    case "ERR_CODE_IDP_REFRESH_FAILED":
      return ErrCode.ERR_CODE_IDP_REFRESH_FAILED;
    case 4773:
    case "ERR_CODE_IDP_REFRESH_INVALID_O2_TOKEN":
      return ErrCode.ERR_CODE_IDP_REFRESH_INVALID_O2_TOKEN;
    case 4774:
    case "ERR_CODE_IDP_REFRESH_SUBJECT_MISMATCH":
      return ErrCode.ERR_CODE_IDP_REFRESH_SUBJECT_MISMATCH;
    case 4775:
    case "ERR_CODE_IDP_LOGOUT_INVALID_ID_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_INVALID_ID_TOKEN;
    case 4776:
    case "ERR_CODE_IDP_LOGOUT_INVALID_EMAIL_IN_ID_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_INVALID_EMAIL_IN_ID_TOKEN;
    case 4777:
    case "ERR_CODE_IDP_LOGOUT_MISSING_TENANT_NAME_PROVIDER_IN_ID_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_MISSING_TENANT_NAME_PROVIDER_IN_ID_TOKEN;
    case 4778:
    case "ERR_CODE_IDP_LOGOUT_UNEXPECTED_TENANT_NAME_PROVIDER_IN_ID_TOKEN":
      return ErrCode.ERR_CODE_IDP_LOGOUT_UNEXPECTED_TENANT_NAME_PROVIDER_IN_ID_TOKEN;
    case 4779:
    case "ERR_CODE_IDP_LOGOUT_CANNOT_DETERMINE_REDIRECT_URI":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CANNOT_DETERMINE_REDIRECT_URI;
    case 4780:
    case "ERR_CODE_IDP_LOGOUT_CREATE_SSO_LOGOUT_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGOUT_CREATE_SSO_LOGOUT_TOKEN_ERROR;
    case 4781:
    case "ERR_CODE_IDP_LOGOUT_SET_SSO_LOGOUT_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_LOGOUT_SET_SSO_LOGOUT_TOKEN_ERROR;
    case 4782:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE;
    case 4783:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN;
    case 4784:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN;
    case 4785:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR;
    case 4786:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT;
    case 4787:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT;
    case 4788:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE;
    case 4789:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY;
    case 4790:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL;
    case 4791:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_STATE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_STATE;
    case 4792:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE;
    case 4793:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE;
    case 4794:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT;
    case 4795:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_NONCE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_NONCE;
    case 4796:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY;
    case 4797:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE_EXPIRY":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE_EXPIRY;
    case 4798:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_SUBJECT":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_SUBJECT;
    case 4799:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_NONCE":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_NONCE;
    case 4800:
    case "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_EXPIRY":
      return ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_EXPIRY;
    case 4801:
    case "ERR_CODE_IDP_FORCE_AUTH_FAILED":
      return ErrCode.ERR_CODE_IDP_FORCE_AUTH_FAILED;
    case 4802:
    case "ERR_CODE_SSO_REFRESH_INVALID_USER_SESSION_COOKIE":
      return ErrCode.ERR_CODE_SSO_REFRESH_INVALID_USER_SESSION_COOKIE;
    case 4803:
    case "ERR_CODE_SSO_AUTH_LOGOUT_PARSE_FORM_ERROR":
      return ErrCode.ERR_CODE_SSO_AUTH_LOGOUT_PARSE_FORM_ERROR;
    case 4804:
    case "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_PROVIDER_FROM_COOKIE_ERR":
      return ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_PROVIDER_FROM_COOKIE_ERR;
    case 4805:
    case "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_USER_SESSION_COOKIE_ERR":
      return ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_USER_SESSION_COOKIE_ERR;
    case 4806:
    case "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_EMAIL_FROM_COOKIE_ERR":
      return ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_EMAIL_FROM_COOKIE_ERR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ErrCode.UNRECOGNIZED;
  }
}

export function errCodeToJSON(object: ErrCode): string {
  switch (object) {
    case ErrCode.ERR_CODE_UNSPECIFIED:
      return "ERR_CODE_UNSPECIFIED";
    case ErrCode.ERR_CODE_INTERNAL:
      return "ERR_CODE_INTERNAL";
    case ErrCode.ERR_CODE_INVALID_UUID:
      return "ERR_CODE_INVALID_UUID";
    case ErrCode.ERR_CODE_PERMISSION_DENIED:
      return "ERR_CODE_PERMISSION_DENIED";
    case ErrCode.ERR_CODE_OUT_OF_RANGE:
      return "ERR_CODE_OUT_OF_RANGE";
    case ErrCode.ERR_CODE_INVALID_TYPE:
      return "ERR_CODE_INVALID_TYPE";
    case ErrCode.ERR_CODE_INVALID_VALUE:
      return "ERR_CODE_INVALID_VALUE";
    case ErrCode.ERR_CODE_UNKNOWN_PARAMETER:
      return "ERR_CODE_UNKNOWN_PARAMETER";
    case ErrCode.ERR_CODE_SERVICE_UNAVAILABLE:
      return "ERR_CODE_SERVICE_UNAVAILABLE";
    case ErrCode.ERR_CODE_NOT_FOUND:
      return "ERR_CODE_NOT_FOUND";
    case ErrCode.ERR_CODE_NOT_IMPLEMENTED:
      return "ERR_CODE_NOT_IMPLEMENTED";
    case ErrCode.ERR_CODE_TOO_MANY_REQUESTS:
      return "ERR_CODE_TOO_MANY_REQUESTS";
    case ErrCode.ERR_CODE_NO_KNOWN_CODE:
      return "ERR_CODE_NO_KNOWN_CODE";
    case ErrCode.ERR_CODE_NO_REGISTERED_MARSHALERS:
      return "ERR_CODE_NO_REGISTERED_MARSHALERS";
    case ErrCode.ERR_CODE_UNSUPPORTED_CONTENT_TYPE:
      return "ERR_CODE_UNSUPPORTED_CONTENT_TYPE";
    case ErrCode.ERR_CODE_DATA_CONFLICT:
      return "ERR_CODE_DATA_CONFLICT";
    case ErrCode.ERR_CODE_UNAUTHORIZED:
      return "ERR_CODE_UNAUTHORIZED";
    case ErrCode.ERR_CODE_READ_ONLY_FIELD:
      return "ERR_CODE_READ_ONLY_FIELD";
    case ErrCode.ERR_CODE_MISSING_REQUIRED_ARG:
      return "ERR_CODE_MISSING_REQUIRED_ARG";
    case ErrCode.ERR_CODE_REQUEST_VALIDATION:
      return "ERR_CODE_REQUEST_VALIDATION";
    case ErrCode.ERR_CODE_INVALID_CLI_CMD:
      return "ERR_CODE_INVALID_CLI_CMD";
    case ErrCode.ERR_CODE_UNSUPPORTED_VALUE:
      return "ERR_CODE_UNSUPPORTED_VALUE";
    case ErrCode.ERR_CODE_METHOD_NOT_ALLOWED:
      return "ERR_CODE_METHOD_NOT_ALLOWED";
    case ErrCode.ERR_CODE_MAX_LIMIT_EXCEEDED:
      return "ERR_CODE_MAX_LIMIT_EXCEEDED";
    case ErrCode.ERR_CODE_CANNOT_UPDATE_MODEL_FOR_GROUP:
      return "ERR_CODE_CANNOT_UPDATE_MODEL_FOR_GROUP";
    case ErrCode.ERR_CODE_JSON_UNMARSHAL_ERROR:
      return "ERR_CODE_JSON_UNMARSHAL_ERROR";
    case ErrCode.ERR_CODE_JSON_MARSHAL_ERROR:
      return "ERR_CODE_JSON_MARSHAL_ERROR";
    case ErrCode.ERR_CODE_JSON_NO_DATA:
      return "ERR_CODE_JSON_NO_DATA";
    case ErrCode.ERR_CODE_CSV_UNMARSHAL_ERROR:
      return "ERR_CODE_CSV_UNMARSHAL_ERROR";
    case ErrCode.ERR_CODE_CSV_MARSHAL_ERROR:
      return "ERR_CODE_CSV_MARSHAL_ERROR";
    case ErrCode.ERR_CODE_CSV_INVALID_DATA:
      return "ERR_CODE_CSV_INVALID_DATA";
    case ErrCode.ERR_CODE_CSV_UNKNOWN_HEADER:
      return "ERR_CODE_CSV_UNKNOWN_HEADER";
    case ErrCode.ERR_CODE_CSV_INVALID_VALUE:
      return "ERR_CODE_CSV_INVALID_VALUE";
    case ErrCode.ERR_CODE_CSV_NO_DATA:
      return "ERR_CODE_CSV_NO_DATA";
    case ErrCode.ERR_CODE_YAML_NO_DATA:
      return "ERR_CODE_YAML_NO_DATA";
    case ErrCode.ERR_CODE_YAML_UNMARSHAL_ERROR:
      return "ERR_CODE_YAML_UNMARSHAL_ERROR";
    case ErrCode.ERR_CODE_YAML_MARSHAL_ERROR:
      return "ERR_CODE_YAML_MARSHAL_ERROR";
    case ErrCode.ERR_CODE_PEM_NO_DATA:
      return "ERR_CODE_PEM_NO_DATA";
    case ErrCode.ERR_CODE_PEM_UNMARSHAL_ERROR:
      return "ERR_CODE_PEM_UNMARSHAL_ERROR";
    case ErrCode.ERR_CODE_PEM_MARSHAL_ERROR:
      return "ERR_CODE_PEM_MARSHAL_ERROR";
    case ErrCode.ERR_CODE_PEM_INVALID_KEY_TYPE:
      return "ERR_CODE_PEM_INVALID_KEY_TYPE";
    case ErrCode.ERR_CODE_PEM_INVALID_KEY_DATA:
      return "ERR_CODE_PEM_INVALID_KEY_DATA";
    case ErrCode.ERR_CODE_FORM_MARSHAL_ERROR:
      return "ERR_CODE_FORM_MARSHAL_ERROR";
    case ErrCode.ERR_CODE_FORM_UNMARSHAL_ERROR:
      return "ERR_CODE_FORM_UNMARSHAL_ERROR";
    case ErrCode.ERR_CODE_FORM_NO_DATA:
      return "ERR_CODE_FORM_NO_DATA";
    case ErrCode.ERR_CODE_NO_FABRICS_DEFINED:
      return "ERR_CODE_NO_FABRICS_DEFINED";
    case ErrCode.ERR_CODE_NO_FABRIC_CONNECTIONS_DEFINED:
      return "ERR_CODE_NO_FABRIC_CONNECTIONS_DEFINED";
    case ErrCode.ERR_CODE_TOO_MANY_FABRICS_DEFINED:
      return "ERR_CODE_TOO_MANY_FABRICS_DEFINED";
    case ErrCode.ERR_CODE_CHASSIS_ALREADY_ASSIGNED:
      return "ERR_CODE_CHASSIS_ALREADY_ASSIGNED";
    case ErrCode.ERR_CODE_NO_PORTS_FOR_CHASSIS:
      return "ERR_CODE_NO_PORTS_FOR_CHASSIS";
    case ErrCode.ERR_CODE_INVALID_CONFIRMATION_CODE:
      return "ERR_CODE_INVALID_CONFIRMATION_CODE";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_ERROR:
      return "ERR_CODE_PROXY_UNKNOWN_ERROR";
    case ErrCode.ERR_CODE_PROXY_TRANSPORT_ERROR:
      return "ERR_CODE_PROXY_TRANSPORT_ERROR";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_ROUTE:
      return "ERR_CODE_PROXY_UNKNOWN_ROUTE";
    case ErrCode.ERR_CODE_PROXY_INVALID_WS_SVC:
      return "ERR_CODE_PROXY_INVALID_WS_SVC";
    case ErrCode.ERR_CODE_PROXY_INVALID_WS_PATH:
      return "ERR_CODE_PROXY_INVALID_WS_PATH";
    case ErrCode.ERR_CODE_PROXY_INVALID_WS_FABRIC_ID:
      return "ERR_CODE_PROXY_INVALID_WS_FABRIC_ID";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING:
      return "ERR_CODE_PROXY_UNKNOWN_PATH_MAPPING";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR:
      return "ERR_CODE_PROXY_AUTH_ERROR";
    case ErrCode.ERR_CODE_PROXY_UNROUTABLE_APP:
      return "ERR_CODE_PROXY_UNROUTABLE_APP";
    case ErrCode.ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP:
      return "ERR_CODE_PROXY_NIL_ORG_SHARD_LOOKUP";
    case ErrCode.ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED:
      return "ERR_CODE_PROXY_ORG_SHARD_LOOKUP_FAILED";
    case ErrCode.ERR_CODE_PROXY_NO_ACTIVE_SHARD:
      return "ERR_CODE_PROXY_NO_ACTIVE_SHARD";
    case ErrCode.ERR_CODE_PROXY_INVALID_ROUTING_POLICY:
      return "ERR_CODE_PROXY_INVALID_ROUTING_POLICY";
    case ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND:
      return "ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_FOUND";
    case ErrCode.ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND:
      return "ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_FOUND";
    case ErrCode.ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY:
      return "ERR_CODE_PROXY_ASSIGNMENT_SVC_ROUTE_NOT_READY";
    case ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID:
      return "ERR_CODE_PROXY_LOAD_BALANCED_HOST_PORT_INVALID";
    case ErrCode.ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID:
      return "ERR_CODE_PROXY_ASSIGNMENT_HOST_PORT_INVALID";
    case ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID:
      return "ERR_CODE_PROXY_CANNOT_ROUTE_NIL_ORG_ID";
    case ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID:
      return "ERR_CODE_PROXY_CANNOT_ROUTE_NIL_FABRIC_ID";
    case ErrCode.ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE:
      return "ERR_CODE_PROXY_CANNOT_ROUTE_BY_RESOURCE";
    case ErrCode.ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS:
      return "ERR_CODE_PROXY_NO_SHARD_FOR_NEW_ORGS";
    case ErrCode.ERR_CODE_PROXY_EMPTY_FABRIC_NAME:
      return "ERR_CODE_PROXY_EMPTY_FABRIC_NAME";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME:
      return "ERR_CODE_PROXY_UNKNOWN_FABRIC_NAME";
    case ErrCode.ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL:
      return "ERR_CODE_PROXY_EMPTY_DEVICE_SERIAL";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL:
      return "ERR_CODE_PROXY_UNKNOWN_DEVICE_SERIAL";
    case ErrCode.ERR_CODE_PROXY_EMPTY_EMAIL:
      return "ERR_CODE_PROXY_EMPTY_EMAIL";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_EMAIL:
      return "ERR_CODE_PROXY_UNKNOWN_EMAIL";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_CLAIMS:
      return "ERR_CODE_PROXY_AUTH_ERROR_CLAIMS";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_NO_ORG:
      return "ERR_CODE_PROXY_AUTH_ERROR_NO_ORG";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_TYPE:
      return "ERR_CODE_PROXY_AUTH_ERROR_TYPE";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE:
      return "ERR_CODE_PROXY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID:
      return "ERR_CODE_PROXY_AUTH_ERROR_DEVICE_ID";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE:
      return "ERR_CODE_PROXY_AUTH_ERROR_UNKNOWN_DEVICE";
    case ErrCode.ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH:
      return "ERR_CODE_PROXY_AUTH_ERROR_FABRIC_MISMATCH";
    case ErrCode.ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION:
      return "ERR_CODE_PROXY_RESOLVE_REDIRECT_LOCATION";
    case ErrCode.ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID:
      return "ERR_CODE_PROXY_HEADER_FABRIC_ID_INVALID";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_TENANT:
      return "ERR_CODE_PROXY_UNKNOWN_TENANT";
    case ErrCode.ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID:
      return "ERR_CODE_PROXY_EMPTY_CUI_TENANT_ID";
    case ErrCode.ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID:
      return "ERR_CODE_PROXY_UNKNOWN_CUI_TENANT_ID";
    case ErrCode.ERR_CODE_PROXY_CROSS_GEO_REDIRECT:
      return "ERR_CODE_PROXY_CROSS_GEO_REDIRECT";
    case ErrCode.ERR_CODE_PROXY_LEGACY_FORWARD_LOOP:
      return "ERR_CODE_PROXY_LEGACY_FORWARD_LOOP";
    case ErrCode.ERR_CODE_PROXY_LEGACY_FORWARD_ERROR:
      return "ERR_CODE_PROXY_LEGACY_FORWARD_ERROR";
    case ErrCode.ERR_CODE_PROXY_GEO_MISMATCH:
      return "ERR_CODE_PROXY_GEO_MISMATCH";
    case ErrCode.ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION:
      return "ERR_CODE_PROXY_CELL_PAIR_IN_TRANSITION";
    case ErrCode.ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY:
      return "ERR_CODE_PROXY_LOAD_BALANCED_SVC_ROUTE_NOT_READY";
    case ErrCode.ERR_CODE_PROXY_UNCLASSIFIED_ERROR:
      return "ERR_CODE_PROXY_UNCLASSIFIED_ERROR";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY:
      return "ERR_CODE_FABRIC_RESTORE_INCOMPATIBLE_TOPOLOGY";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR:
      return "ERR_CODE_FABRIC_RESTORE_INTERNAL_ERROR";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR:
      return "ERR_CODE_FABRIC_RESTORE_TRANSACTION_ERROR";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND:
      return "ERR_CODE_FABRIC_RESTORE_REVISION_NOT_FOUND";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED:
      return "ERR_CODE_FABRIC_RESTORE_REVISION_NOT_DESIGN_BASED";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND:
      return "ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_FOUND";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED:
      return "ERR_CODE_FABRIC_RESTORE_RUNNING_NOT_DESIGN_BASED";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE:
      return "ERR_CODE_FABRIC_RESTORE_DELETE_UNUSED_NODE";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR:
      return "ERR_CODE_FABRIC_RESTORE_WRONG_PASSWORD_ERROR";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR:
      return "ERR_CODE_FABRIC_RESTORE_EMPTY_PASSWORD_ERROR";
    case ErrCode.ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR:
      return "ERR_CODE_FABRIC_RESTORE_SECRET_DATA_ERROR";
    case ErrCode.ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW:
      return "ERR_CODE_DELETED_FABRIC_EXCEED_RETENTION_WINDOW";
    case ErrCode.ERR_CODE_DELETED_FABRIC_NOT_FOUND:
      return "ERR_CODE_DELETED_FABRIC_NOT_FOUND";
    case ErrCode.ERR_CODE_CLAIMS_UNKNOWN_DEVICE:
      return "ERR_CODE_CLAIMS_UNKNOWN_DEVICE";
    case ErrCode.ERR_CODE_CLAIMS_ORG_MISMATCH:
      return "ERR_CODE_CLAIMS_ORG_MISMATCH";
    case ErrCode.ERR_CODE_CLAIMS_FABRIC_MISMATCH:
      return "ERR_CODE_CLAIMS_FABRIC_MISMATCH";
    case ErrCode.ERR_CODE_CLAIMS_ORG_NOT_FOUND:
      return "ERR_CODE_CLAIMS_ORG_NOT_FOUND";
    case ErrCode.ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND:
      return "ERR_CODE_CLAIMS_PROVIDER_NOT_FOUND";
    case ErrCode.ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND:
      return "ERR_CODE_CLAIMS_USER_EMAIL_NOT_FOUND";
    case ErrCode.ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND:
      return "ERR_CODE_CLAIMS_USER_TENANT_ID_NOT_FOUND";
    case ErrCode.ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND:
      return "ERR_CODE_CLAIMS_SESSION_ID_NOT_FOUND";
    case ErrCode.ERR_CODE_RELAY_NO_HTTP_CONTEXT:
      return "ERR_CODE_RELAY_NO_HTTP_CONTEXT";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_CLAIMS:
      return "ERR_CODE_RELAY_AUTH_ERROR_CLAIMS";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_NO_ORG:
      return "ERR_CODE_RELAY_AUTH_ERROR_NO_ORG";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE:
      return "ERR_CODE_RELAY_AUTH_ERROR_NO_FABRIC_FOR_DEVICE";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID:
      return "ERR_CODE_RELAY_AUTH_ERROR_DEVICE_ID";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE:
      return "ERR_CODE_RELAY_AUTH_ERROR_UNKNOWN_DEVICE";
    case ErrCode.ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH:
      return "ERR_CODE_RELAY_AUTH_ERROR_FABRIC_MISMATCH";
    case ErrCode.ERR_CODE_AUTH_UNKNOWN_SUBJECT:
      return "ERR_CODE_AUTH_UNKNOWN_SUBJECT";
    case ErrCode.ERR_CODE_AUTH_EMPTY_SUBJECT:
      return "ERR_CODE_AUTH_EMPTY_SUBJECT";
    case ErrCode.ERR_CODE_AUTH_EMPTY_PROVIDER:
      return "ERR_CODE_AUTH_EMPTY_PROVIDER";
    case ErrCode.ERR_CODE_AUTH_INVALID_SUBJECT:
      return "ERR_CODE_AUTH_INVALID_SUBJECT";
    case ErrCode.ERR_CODE_AUTH_STALE_SESSION:
      return "ERR_CODE_AUTH_STALE_SESSION";
    case ErrCode.ERR_CODE_AUTH_USER_NOT_FOUND:
      return "ERR_CODE_AUTH_USER_NOT_FOUND";
    case ErrCode.ERR_CODE_AUTH_ORG_MISMATCH:
      return "ERR_CODE_AUTH_ORG_MISMATCH";
    case ErrCode.ERR_CODE_AUTH_TOKEN_EXPIRED:
      return "ERR_CODE_AUTH_TOKEN_EXPIRED";
    case ErrCode.ERR_CODE_AUTH_TOKEN_NOT_YET_VALID:
      return "ERR_CODE_AUTH_TOKEN_NOT_YET_VALID";
    case ErrCode.ERR_CODE_AUTH_TOKEN_MALFORMED:
      return "ERR_CODE_AUTH_TOKEN_MALFORMED";
    case ErrCode.ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID:
      return "ERR_CODE_AUTH_TOKEN_SIGNATURE_INVALID";
    case ErrCode.ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID:
      return "ERR_CODE_AUTH_TOKEN_CLAIMS_INVALID";
    case ErrCode.ERR_CODE_AUTH_TOKEN_NOT_FOUND:
      return "ERR_CODE_AUTH_TOKEN_NOT_FOUND";
    case ErrCode.ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR:
      return "ERR_CODE_AUTH_TOKEN_VALIDATION_ERROR";
    case ErrCode.ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR:
      return "ERR_CODE_AUTH_TOKEN_UNEXPECTED_VALIDATION_ERROR";
    case ErrCode.ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES:
      return "ERR_CODE_RESERVATION_PENDING_CANDIDATE_CHANGES";
    case ErrCode.ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED:
      return "ERROR_CODE_IMAGE_MANIFEST_NOT_SYNCED";
    case ErrCode.ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST:
      return "ERR_CODE_IDP_GET_USER_INFO_CANNOT_CREATE_REQUEST";
    case ErrCode.ERR_CODE_IDP_GET_USER_INFO_ERROR:
      return "ERR_CODE_IDP_GET_USER_INFO_ERROR";
    case ErrCode.ERR_CODE_IDP_GET_USER_INFO_UNEXPECTED_RESPONSE_STATUS:
      return "ERR_CODE_IDP_GET_USER_INFO_UNEXPECTED_RESPONSE_STATUS";
    case ErrCode.ERR_CODE_IDP_GET_USER_INFO_INVALID_RESPONSE:
      return "ERR_CODE_IDP_GET_USER_INFO_INVALID_RESPONSE";
    case ErrCode.ERR_CODE_IDP_LOGIN_NO_EMAIL:
      return "ERR_CODE_IDP_LOGIN_NO_EMAIL";
    case ErrCode.ERR_CODE_IDP_LOGIN_CANNOT_DETERMINE_REDIRECT_URI:
      return "ERR_CODE_IDP_LOGIN_CANNOT_DETERMINE_REDIRECT_URI";
    case ErrCode.ERR_CODE_IDP_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_LOGIN_SET_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGIN_SET_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CUI_DISABLED:
      return "ERR_CODE_IDP_C3_LOGIN_CUI_DISABLED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_C3_LOGIN_DISABLED:
      return "ERR_CODE_IDP_C3_LOGIN_C3_LOGIN_DISABLED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_EMAIL:
      return "ERR_CODE_IDP_C3_LOGIN_NO_EMAIL";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_SLOT_STATE:
      return "ERR_CODE_IDP_C3_LOGIN_NO_SLOT_STATE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_NO_START_URL:
      return "ERR_CODE_IDP_C3_LOGIN_NO_START_URL";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_INVALID_START_URL:
      return "ERR_CODE_IDP_C3_LOGIN_INVALID_START_URL";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CANNOT_DETERMINE_REDIRECT_URI:
      return "ERR_CODE_IDP_C3_LOGIN_CANNOT_DETERMINE_REDIRECT_URI";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_C3_LOGIN_CREATE_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_SET_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_C3_LOGIN_SET_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_CUI_DISABLED:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_CUI_DISABLED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_C3_LOGIN_DISABLED:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_C3_LOGIN_DISABLED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_AUTH_CODE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_AUTH_CODE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMAIL_MISMATCH:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMAIL_MISMATCH";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_START_URL:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_START_URL";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MALFORMED_START_URL:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MALFORMED_START_URL";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_NO_STATE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_NO_STATE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_START_URL:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_START_URL";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_START_URL_DOMAIN:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_START_URL_DOMAIN";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_START_URL:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_START_URL";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_REDIRECT_URI:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_REDIRECT_URI";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_NONCE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_NONCE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_EXPIRY:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_STATE_EXPIRY";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_NONCE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_NONCE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_EXPIRY:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_EXPIRY";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_CUI_TENANT_ID:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_CUI_TENANT_ID";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_PROVIDER:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_MISMATCHED_TARGET_PROVIDER";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_EXPIRED_SSO_LOGOUT_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_EXPIRED_SSO_LOGOUT_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_MISSING_SSO_LOGOUT_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_MISSING_SSO_LOGOUT_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_LOGOUT_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_SSO_LOGOUT_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_NONCE:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_NONCE";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL_DOMAIN:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_INVALID_SSO_LOGOUT_TOKEN_START_URL_DOMAIN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_NO_STATE:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_NO_STATE";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CALLBACK_MISMATCHED_SUBJECT:
      return "ERR_CODE_IDP_LOGOUT_CALLBACK_MISMATCHED_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_NO_AUTH_CODE:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_NO_AUTH_CODE";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_CONFIG_FAILED";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_GET_OAUTH_TOKEN_FAILED";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_VALIDATE_OAUTH_TOKEN_FAILED";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_ID_TOKEN_NONCE_MISMATCH";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_EMAIL_MISMATCH:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_EMAIL_MISMATCH";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SANITY_CHECK_FAILED:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_SANITY_CHECK_FAILED";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_USER_INFO_SUBJECT:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_USER_INFO_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_ID_TOKEN_SUBJECT:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_INVALID_ID_TOKEN_SUBJECT";
    case ErrCode.ERR_CODE_IDP_LOGIN_CALLBACK_SUBJECT_MISMATCH:
      return "ERR_CODE_IDP_LOGIN_CALLBACK_SUBJECT_MISMATCH";
    case ErrCode.ERR_CODE_IDP_REFRESH_NO_TOKEN:
      return "ERR_CODE_IDP_REFRESH_NO_TOKEN";
    case ErrCode.ERR_CODE_IDP_REFRESH_CANNOT_DETERMINE_CONFIGURATION:
      return "ERR_CODE_IDP_REFRESH_CANNOT_DETERMINE_CONFIGURATION";
    case ErrCode.ERR_CODE_IDP_REFRESH_FAILED:
      return "ERR_CODE_IDP_REFRESH_FAILED";
    case ErrCode.ERR_CODE_IDP_REFRESH_INVALID_O2_TOKEN:
      return "ERR_CODE_IDP_REFRESH_INVALID_O2_TOKEN";
    case ErrCode.ERR_CODE_IDP_REFRESH_SUBJECT_MISMATCH:
      return "ERR_CODE_IDP_REFRESH_SUBJECT_MISMATCH";
    case ErrCode.ERR_CODE_IDP_LOGOUT_INVALID_ID_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_INVALID_ID_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_INVALID_EMAIL_IN_ID_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_INVALID_EMAIL_IN_ID_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_MISSING_TENANT_NAME_PROVIDER_IN_ID_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_MISSING_TENANT_NAME_PROVIDER_IN_ID_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_UNEXPECTED_TENANT_NAME_PROVIDER_IN_ID_TOKEN:
      return "ERR_CODE_IDP_LOGOUT_UNEXPECTED_TENANT_NAME_PROVIDER_IN_ID_TOKEN";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CANNOT_DETERMINE_REDIRECT_URI:
      return "ERR_CODE_IDP_LOGOUT_CANNOT_DETERMINE_REDIRECT_URI";
    case ErrCode.ERR_CODE_IDP_LOGOUT_CREATE_SSO_LOGOUT_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGOUT_CREATE_SSO_LOGOUT_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_LOGOUT_SET_SSO_LOGOUT_TOKEN_ERROR:
      return "ERR_CODE_IDP_LOGOUT_SET_SSO_LOGOUT_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_TOKEN_VALIDATOR_UNAVAILABLE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EXPIRED_SSO_STATE_TOKEN";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISSING_SSO_STATE_TOKEN";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_SSO_STATE_TOKEN_ERROR";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_SUBJECT";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_UNEXPECTED_INVALID_SSO_STATE_TOKEN_SUBJECT";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_NONCE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_EXPIRY";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_SSO_STATE_TOKEN_START_URL";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_STATE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_NO_STATE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_SUBJECT";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_NONCE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_NONCE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_EMPTY_STATE_EXPIRY";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE_EXPIRY:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_INVALID_STATE_EXPIRY";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_SUBJECT:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_SUBJECT";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_NONCE:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_NONCE";
    case ErrCode.ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_EXPIRY:
      return "ERR_CODE_IDP_C3_LOGIN_CALLBACK_MISMATCHED_EXPIRY";
    case ErrCode.ERR_CODE_IDP_FORCE_AUTH_FAILED:
      return "ERR_CODE_IDP_FORCE_AUTH_FAILED";
    case ErrCode.ERR_CODE_SSO_REFRESH_INVALID_USER_SESSION_COOKIE:
      return "ERR_CODE_SSO_REFRESH_INVALID_USER_SESSION_COOKIE";
    case ErrCode.ERR_CODE_SSO_AUTH_LOGOUT_PARSE_FORM_ERROR:
      return "ERR_CODE_SSO_AUTH_LOGOUT_PARSE_FORM_ERROR";
    case ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_PROVIDER_FROM_COOKIE_ERR:
      return "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_PROVIDER_FROM_COOKIE_ERR";
    case ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_USER_SESSION_COOKIE_ERR:
      return "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_USER_SESSION_COOKIE_ERR";
    case ErrCode.ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_EMAIL_FROM_COOKIE_ERR:
      return "ERR_CODE_SSO_AUTH_LOGIN_VALIDATE_GET_EMAIL_FROM_COOKIE_ERR";
    case ErrCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum WarnCode {
  WARN_CODE_UNSPECIFIED = 0,
  WARN_CODE_FABRIC_RESTORE_DELETED_NODE = 1,
  WARN_CODE_FABRIC_RESTORE_UNBOUND_NODE = 2,
  WARN_CODE_FABRIC_RESTORE_CHANGED_NODE_BINDING = 3,
  UNRECOGNIZED = -1,
}

export function warnCodeFromJSON(object: any): WarnCode {
  switch (object) {
    case 0:
    case "WARN_CODE_UNSPECIFIED":
      return WarnCode.WARN_CODE_UNSPECIFIED;
    case 1:
    case "WARN_CODE_FABRIC_RESTORE_DELETED_NODE":
      return WarnCode.WARN_CODE_FABRIC_RESTORE_DELETED_NODE;
    case 2:
    case "WARN_CODE_FABRIC_RESTORE_UNBOUND_NODE":
      return WarnCode.WARN_CODE_FABRIC_RESTORE_UNBOUND_NODE;
    case 3:
    case "WARN_CODE_FABRIC_RESTORE_CHANGED_NODE_BINDING":
      return WarnCode.WARN_CODE_FABRIC_RESTORE_CHANGED_NODE_BINDING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WarnCode.UNRECOGNIZED;
  }
}

export function warnCodeToJSON(object: WarnCode): string {
  switch (object) {
    case WarnCode.WARN_CODE_UNSPECIFIED:
      return "WARN_CODE_UNSPECIFIED";
    case WarnCode.WARN_CODE_FABRIC_RESTORE_DELETED_NODE:
      return "WARN_CODE_FABRIC_RESTORE_DELETED_NODE";
    case WarnCode.WARN_CODE_FABRIC_RESTORE_UNBOUND_NODE:
      return "WARN_CODE_FABRIC_RESTORE_UNBOUND_NODE";
    case WarnCode.WARN_CODE_FABRIC_RESTORE_CHANGED_NODE_BINDING:
      return "WARN_CODE_FABRIC_RESTORE_CHANGED_NODE_BINDING";
    case WarnCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * A REST API Error is returned when the Hyperfabric service failed to execute
 * the received REST API request to inform the user on the type of the error and other
 * useful information for troubleshooting the request.
 */
export interface RestError {
  /** The error message. */
  message: string;
  /** The name of the relevant field. */
  field: string;
  /** The value of the relevant field. */
  value: string;
  /** Additional information about the error. */
  notes: string;
  /** The HTTP status code associated with the error. */
  status: number;
  /** The flag that indicates if the error is a critical error or not. */
  critical: boolean;
  /** An additional REST error code. */
  errCode: ErrCode;
  /** A unique identifier for each request, used for tracking purposes. */
  trackingId: string;
  /** A list of underlying causes. */
  causes: string[];
  tag: string;
  /** The API path of the request. */
  api: string;
  /** The HTTP method of the request. */
  method: string;
}

/**
 * A REST API Warning is returned when the Hyperfabric service accepts the REST API request however with warnings to inform
 * the user on the configuration modifications that were made to the request or the consequence of executing the request.
 */
export interface RestWarning {
  /** The error message. */
  message: string;
  /** The name of the relevant field. */
  field: string;
  /** The value of the relevant field. */
  value: string;
  /** Additional information about the warning. */
  notes: string;
  /** The warning code. */
  warnCode: WarnCode;
  /** A unique identifier for each request, used for tracking purposes. */
  trackingId: string;
  /** A list of underlying causes. */
  causes: string[];
}

function createBaseRestError(): RestError {
  return {
    message: "",
    field: "",
    value: "",
    notes: "",
    status: 0,
    critical: false,
    errCode: 0,
    trackingId: "",
    causes: [],
    tag: "",
    api: "",
    method: "",
  };
}

export const RestError: MessageFns<RestError> = {
  encode(message: RestError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.field !== "") {
      writer.uint32(18).string(message.field);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    if (message.notes !== "") {
      writer.uint32(34).string(message.notes);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.critical !== false) {
      writer.uint32(48).bool(message.critical);
    }
    if (message.errCode !== 0) {
      writer.uint32(56).int32(message.errCode);
    }
    if (message.trackingId !== "") {
      writer.uint32(66).string(message.trackingId);
    }
    for (const v of message.causes) {
      writer.uint32(74).string(v!);
    }
    if (message.tag !== "") {
      writer.uint32(82).string(message.tag);
    }
    if (message.api !== "") {
      writer.uint32(90).string(message.api);
    }
    if (message.method !== "") {
      writer.uint32(98).string(message.method);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.field = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.critical = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.errCode = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.trackingId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.causes.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.tag = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.api = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.method = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestError {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      critical: isSet(object.critical) ? globalThis.Boolean(object.critical) : false,
      errCode: isSet(object.errCode) ? errCodeFromJSON(object.errCode) : 0,
      trackingId: isSet(object.trackingId) ? globalThis.String(object.trackingId) : "",
      causes: globalThis.Array.isArray(object?.causes) ? object.causes.map((e: any) => globalThis.String(e)) : [],
      tag: isSet(object.tag) ? globalThis.String(object.tag) : "",
      api: isSet(object.api) ? globalThis.String(object.api) : "",
      method: isSet(object.method) ? globalThis.String(object.method) : "",
    };
  },

  toJSON(message: RestError): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.critical !== false) {
      obj.critical = message.critical;
    }
    if (message.errCode !== 0) {
      obj.errCode = errCodeToJSON(message.errCode);
    }
    if (message.trackingId !== "") {
      obj.trackingId = message.trackingId;
    }
    if (message.causes?.length) {
      obj.causes = message.causes;
    }
    if (message.tag !== "") {
      obj.tag = message.tag;
    }
    if (message.api !== "") {
      obj.api = message.api;
    }
    if (message.method !== "") {
      obj.method = message.method;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestError>, I>>(base?: I): RestError {
    return RestError.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestError>, I>>(object: I): RestError {
    const message = createBaseRestError();
    message.message = object.message ?? "";
    message.field = object.field ?? "";
    message.value = object.value ?? "";
    message.notes = object.notes ?? "";
    message.status = object.status ?? 0;
    message.critical = object.critical ?? false;
    message.errCode = object.errCode ?? 0;
    message.trackingId = object.trackingId ?? "";
    message.causes = object.causes?.map((e) => e) || [];
    message.tag = object.tag ?? "";
    message.api = object.api ?? "";
    message.method = object.method ?? "";
    return message;
  },
};

function createBaseRestWarning(): RestWarning {
  return { message: "", field: "", value: "", notes: "", warnCode: 0, trackingId: "", causes: [] };
}

export const RestWarning: MessageFns<RestWarning> = {
  encode(message: RestWarning, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.field !== "") {
      writer.uint32(18).string(message.field);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    if (message.notes !== "") {
      writer.uint32(34).string(message.notes);
    }
    if (message.warnCode !== 0) {
      writer.uint32(40).int32(message.warnCode);
    }
    if (message.trackingId !== "") {
      writer.uint32(50).string(message.trackingId);
    }
    for (const v of message.causes) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestWarning {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestWarning();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.field = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.notes = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.warnCode = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.trackingId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.causes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestWarning {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
      notes: isSet(object.notes) ? globalThis.String(object.notes) : "",
      warnCode: isSet(object.warnCode) ? warnCodeFromJSON(object.warnCode) : 0,
      trackingId: isSet(object.trackingId) ? globalThis.String(object.trackingId) : "",
      causes: globalThis.Array.isArray(object?.causes) ? object.causes.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: RestWarning): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    if (message.notes !== "") {
      obj.notes = message.notes;
    }
    if (message.warnCode !== 0) {
      obj.warnCode = warnCodeToJSON(message.warnCode);
    }
    if (message.trackingId !== "") {
      obj.trackingId = message.trackingId;
    }
    if (message.causes?.length) {
      obj.causes = message.causes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestWarning>, I>>(base?: I): RestWarning {
    return RestWarning.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestWarning>, I>>(object: I): RestWarning {
    const message = createBaseRestWarning();
    message.message = object.message ?? "";
    message.field = object.field ?? "";
    message.value = object.value ?? "";
    message.notes = object.notes ?? "";
    message.warnCode = object.warnCode ?? 0;
    message.trackingId = object.trackingId ?? "";
    message.causes = object.causes?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
